import { BREAKPOINT_DESKTOP_PX } from '../global/constants'
import { useMediaQuery } from '../global/useMediaQuery'

export const useIsDesktopScreen = (): boolean => {
  return useMediaQuery(`(min-width: ${BREAKPOINT_DESKTOP_PX}px)`)
}
